var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions } from 'react-redux-form';
import { wrapDispatch } from "../../Multireducer";
import { Icon } from "../../UI";
import { DropdownList } from "../../Forms";


import { omit } from 'lodash';
import {
  filterTemplates,
  getPropertySortType,
  getSortOptions } from "../helpers/sortComponets";










const mapStateToProps = (state, ownProps) => {
  let { templates } = state;
  const stateProperty = ownProps.stateProperty ? ownProps.stateProperty : 'library.search';

  if (ownProps.selectedTemplates && ownProps.selectedTemplates.count()) {
    templates = filterTemplates(state.templates, ownProps.selectedTemplates);
  }
  const search = stateProperty.
  split(/[.,/]/).
  reduce(
    (memo, property) =>
    Object.keys(memo).indexOf(property) !== -1 ? memo[property] : null,
    state
  );
  return _objectSpread(_objectSpread({}, ownProps), {}, { stateProperty, search, templates });
};

const mapDispatchToProps = (dispatch) =>
bindActionCreators({ merge: actions.merge }, wrapDispatch(dispatch, 'library'));

const connector = connect(mapStateToProps, mapDispatchToProps);



const getToggleSearchIcon = (search) =>
search.order === 'asc' && search.sort !== '_score' ? 'arrow-up' : 'arrow-down';

const validateSearch = (search) =>
search.sort === '_score' && !search.searchTerm ?
{
  sort: 'creationDate',
  order: 'desc',
  searchTerm: search.searchTerm
} :
{ searchTerm: search.searchTerm, sort: search.sort };

const sortDirection = (condition) => {
  switch (condition) {
    case 'desc':
    case 'string':
      return 'asc';
    case 'asc':
    default:
      return 'desc';
  }
};

const SortButtonsComponent = ({
  search,
  merge,
  stateProperty,
  templates,
  sortCallback
}) => {
  const doSort = (property, defaultTreatAs, selectedSort) => {
    const treatAs = defaultTreatAs;
    const order = selectedSort || sortDirection(treatAs);
    const newSort = { sort: property, order, treatAs };
    merge(stateProperty, newSort);
    const filters = _objectSpread(_objectSpread(_objectSpread({}, search), omit(newSort, 'treatAs')), {}, { userSelectedSorting: true });
    return sortCallback && sortCallback({ search: filters }, 'library');
  };

  const changeOrder = () => {
    doSort(search.sort, search.treatAs, sortDirection(search.order));
  };

  const validatedSearch = validateSearch(search);

  const sortOptions = getSortOptions(search, templates);

  return /*#__PURE__*/(
    _jsx("div", { className: "sort-buttons" }, void 0, /*#__PURE__*/
    _jsx(DropdownList, {
      className: "sort-dropdown",
      value: validatedSearch.sort,
      data: sortOptions,
      valueField: "value",
      textField: "label",
      onChange: (selected) => doSort(selected.value, getPropertySortType(selected)) }
    ), /*#__PURE__*/
    _jsx("button", {
      type: "button",
      disabled: search.sort === '_score',
      className: `sorting-toggle ${search.sort === '_score' && 'disabled'}`,
      onClick: changeOrder }, void 0, /*#__PURE__*/

    _jsx(Icon, { icon: getToggleSearchIcon(search) })
    )
    ));

};

const container = connector(SortButtonsComponent);

export { container as SortButtons, mapStateToProps };